export default __webpack_public_path__ + "static/media/Pregnancyred.3bea4cb2.svg";